<span>publié le {{getFormattedDate(post.publishedAt)}}</span>
<span class="third_infos__admin"> - </span>
<!-- <span class="third_infos__admin">validé le {{getFormattedDate(post.validatedAt)}}</span>
<span class="third_infos__admin"> - </span>
 --><span class="third_infos__admin">expire le {{getFormattedDate(post.expireAt)}}</span>